import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { CustomerService } from "@/components/ui/sections/CustomerService";
import type { CustomerServiceStoryblok } from "@/generated/sb/sb-types";

export const CustomerServiceBlok = ({ blok }: BlokProps<CustomerServiceStoryblok>) => {
	return (
		<BlokWrap editable={blok}>
			<CustomerService
				heading={blok.heading}
				intro={renderRichText(blok.intro)}
				consent={renderRichText(blok.consent)}
				topics={blok.topics}
				// Per-story labels/placeholders/submit come from these Storyblok
				// content fields. Only the validation + alert strings (which have
				// no content field) are sourced from `customerService.*` translations.
				content={{
					emailLabel: blok.emailLabel,
					emailPlaceholder: blok.emailPlaceholder,
					topicLabel: blok.topicLabel,
					topicPlaceholder: blok.topicPlaceholder,
					messageLabel: blok.messageLabel,
					messagePlaceholder: blok.messagePlaceholder,
					submitLabel: blok.submitLabel,
				}}
			/>
		</BlokWrap>
	);
};
